import { useState, useEffect } from "react";
import { styled, keyframes } from "styled-components";
import Testimonial from "./Testimonial";

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px;
  gap: 40px;
  width: 100%;
  background: ${({ theme }) => theme.gradients.darkBlue};
  box-sizing: border-box;

  @media (max-width: 1023px) {
    padding: 60px 60px 40px;
    gap: 40px;
  }

  @media (max-width: 767px) {
    padding: 40px 20px 30px;
    gap: 30px;
  }
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 40px;
  width: 100%;
  max-width: 1608px;

  @media (max-width: 767px) {
    gap: 30px;
  }
`;

const SectionTitle = styled.h2`
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;

  @media (max-width: 767px) {
    font-size: 28px;
  }
`;

const TestimonialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const TestimonialWrapper = styled.div`
  animation: ${fadeIn} 0.5s ease-in-out;
`;

interface TestimonialData {
  avatarUrl?: string;
  authorName?: string;
  text: string;
  moreLink?: string;
}

interface TestimonialSectionProps {
  title?: string;
  testimonials: TestimonialData[];
}

const TestimonialSection = ({
  title = "Od našich výherců",
  testimonials,
}: TestimonialSectionProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (testimonials.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  if (testimonials.length === 0) return null;

  const currentTestimonial = testimonials[currentIndex];

  return (
    <SectionWrapper>
      <SectionContent>
        <SectionTitle>{title}</SectionTitle>
        <TestimonialsContainer>
          <TestimonialWrapper key={currentIndex}>
            <Testimonial
              avatarUrl={currentTestimonial.avatarUrl}
              authorName={currentTestimonial.authorName}
              text={currentTestimonial.text}
              moreLink={currentTestimonial.moreLink}
            />
          </TestimonialWrapper>
        </TestimonialsContainer>
      </SectionContent>
    </SectionWrapper>
  );
};

export default TestimonialSection;
